export const ROOT = 'settings-fullscreen-mobile';
